module.exports = __webpack_public_path__ + "static/media/L1.518fc236.png";